import React, {
  useCallback,
  useMemo,
  useState,
  useEffect,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sendGaComponentEvent from '@gc-npm/utils.metrics.send-ga-component-event';

import { actions as recomendatorActions } from '@/reducers/recomendator';
import Select from '@/components/select';
import { isEmpty, isArrayNotEmpty } from '@/utils/validations';

export const CardSelect = ({
  hiringDetails,
  items,
  idCard,
  oldSelectedItems,
}) => {
  const selectedItems = useSelector((state) => state.recomendator.selectedItems);
  const dispatch = useDispatch();
  const [activeSelectId, setActiveSelectId] = useState(null);

  const rawSelectGroups = useMemo(() => {
    const groups = [];
    if (
      hiringDetails
      && hiringDetails['cms-json-rules-1']
      && isArrayNotEmpty(hiringDetails['cms-json-rules-1'])
    ) {
      const rules = hiringDetails['cms-json-rules-1'];
      rules.forEach((x) => {
        if (!isEmpty(x?.logic?.inputSelects)) {
          groups.push({
            idData: x?.id,
            multibundleData: x?.logic?.multiBundle,
            inputSelects: x.logic.inputSelects,
          });
        }
      });
    }
    return groups;
  }, [hiringDetails]);

  const validSelectGroups = useMemo(() => {
    return rawSelectGroups
      .map((group) => {
        const validInputs = group.inputSelects
          .map((select) => {
            const hasSin = select.options.some((opt) => /^Sin\b/i.test(opt.labelRecomendador) && opt.selected);
            const filtered = select.options.filter((opt) => !/^Sin\b/i.test(opt.labelRecomendador));
            return hasSin ? null : { ...select, options: filtered };
          })
          .filter(Boolean)
          .filter((select) => select.options.length > 0);
        return {
          ...group,
          inputSelects: validInputs,
        };
      })
      .filter((group) => isArrayNotEmpty(group.inputSelects));
  }, [rawSelectGroups]);

  const initialSelectedOptions = useMemo(() => {
    return validSelectGroups.map((group) => group.inputSelects.map((select) => {
      const ordered = select.options.sort((a, b) => a.order - b.order);
      const preselected = ordered.find((opt) => opt.selected);
      return preselected ? preselected.value : ordered[0]?.value || '';
    }));
  }, [validSelectGroups]);

  const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);

  useEffect(() => {
    setSelectedOptions(initialSelectedOptions);
  }, [initialSelectedOptions]);

  const findMultibundleGroup = (newOptionId, imputName, idPartialKeys, group) => {
    let newMultibundlePartialId = '';
    let oldMultibundlePartialId = '';
    const partialKeys = { Netflix: '', Disney: '' };

    switch (idPartialKeys[0]) {
      case '99400':
        if (imputName === 'Netflix') {
          partialKeys.Netflix = newOptionId;
          partialKeys.Disney = idPartialKeys[2];
          newMultibundlePartialId = `${newOptionId}_${idPartialKeys[2]}`;
          oldMultibundlePartialId = `${idPartialKeys[1]}_${idPartialKeys[2]}`;
        } else {
          partialKeys.Disney = newOptionId;
          partialKeys.Netflix = idPartialKeys[1];
          newMultibundlePartialId = `${idPartialKeys[1]}_${newOptionId}`;
          oldMultibundlePartialId = `${idPartialKeys[1]}_${idPartialKeys[2]}`;
        }
        break;
      case '99401':
        partialKeys.Disney = newOptionId;
        newMultibundlePartialId = `${newOptionId}`;
        oldMultibundlePartialId = `${idPartialKeys[1]}`;
        break;
      case '99402':
        partialKeys.Netflix = newOptionId;
        newMultibundlePartialId = `${newOptionId}`;
        oldMultibundlePartialId = `${idPartialKeys[1]}`;
        break;
      default:
        break;
    }

    const multibundle = group.multibundleData;
    const oldIds = multibundle.modulesCombinations[oldMultibundlePartialId]?.idAtom || [];
    const newIds = multibundle.modulesCombinations[newMultibundlePartialId]?.idAtom || [];
    const idsToDeleteNew = multibundle.modulesCombinations[newMultibundlePartialId]?.idsToDelete
      || [];

    return {
      multibundle,
      oldIds,
      newIds,
      idsToDeleteNew,
    };
  }

  const findMultibundleGroupSelected = (idPartialKeys, group) => {
    let oldMultibundlePartialId = '';
    let addNumber = null;
    let newIds = [];
    let oldIds = [];
    if (group) {
      switch (idPartialKeys[0]) {
        case '99400':
          oldMultibundlePartialId = `${idPartialKeys[1]}_${idPartialKeys[2]}`;
          break;
        case '99401':
          oldMultibundlePartialId = `${idPartialKeys[1]}`;
          addNumber = '3874';
          break;
        case '99402':
          oldMultibundlePartialId = `${idPartialKeys[1]}`;
          break;
        default:
          break;
      }

      const multibundle = group.multibundleData;
      newIds = multibundle.modulesCombinations[oldMultibundlePartialId]?.idAtom || [];
      oldIds = Object.entries(multibundle.modulesCombinations)
        .filter(([key]) => key !== oldMultibundlePartialId)
        .flatMap(([, value]) => value?.idAtom || []);

      if (addNumber) {
        oldIds = [...oldIds, addNumber];
      }
    }

    return {
      oldIds,
      newIds,
    };
  }
  const handleSelectChange = useCallback(
    (groupIndex, inputIndex, newOptionId, labelRecomendador, imputName) => {
      setSelectedOptions((prev) => {
        const updated = [...prev];
        if (updated[groupIndex][inputIndex] === newOptionId) return prev;

        updated[groupIndex][inputIndex] = newOptionId;

        const group = validSelectGroups[groupIndex];
        const otherGroups = validSelectGroups.filter((_, index) => index !== groupIndex);
        let idPartialKeysOthers = '';
        if (isArrayNotEmpty(otherGroups)) {
          idPartialKeysOthers = otherGroups[0].idData.split('_');
        }

        const idPartialKeys = group.idData.split('_');
        const {
          oldIds,
          newIds,
          idsToDeleteNew,
        } = findMultibundleGroup(newOptionId, imputName, idPartialKeys, group);

        const {
          newIds: newIds2,
          oldIds: oldIds2,
        } = findMultibundleGroupSelected(idPartialKeysOthers, otherGroups[0]);

        const oldSet = new Set([...oldIds, ...oldIds2]);
        const newSet = new Set([...newIds, ...newIds2]);

       
let updatedTvChannels = Array.isArray(selectedItems.tvChannels)
  ? [...selectedItems.tvChannels]
  : [];

// Aplicar filtros previos (si los necesitas)
updatedTvChannels = updatedTvChannels
  .filter((id) => !oldSet.has(id) && !newSet.has(id))
  .filter((id) => !idsToDeleteNew.includes(id));

// Aquí se sustituyen todos los ids por solo los nuevos
updatedTvChannels = [...newIds, ...newIds2];


        let product = idCard;
        if (!product) {
          product = Array.isArray(items)
            ? items
              .filter((item) => typeof item.id === 'string' && !item.id.startsWith('9940'))
              .map((item) => item.id)
              .join(';')
            : '';
        }

        if (hiringDetails && isArrayNotEmpty(hiringDetails['cms-json-rules-1'])) {
          const traductorProducts = hiringDetails['cms-json-rules-1']
            .filter((item) => String(item.id).startsWith('9940'))
            .flatMap((item) => item.logic?.output ?? [])
            .join(';');
          if (traductorProducts) {
            product = `${product};${traductorProducts}`;
          }
        }

        sendGaComponentEvent({
          componentName: 'selector-card-recomendador',
          componentProduct: product,
          componentContent: labelRecomendador,
          componentVariation: 'all',
        });

        dispatch(
          recomendatorActions.recomendPackages({
            tvchanels: updatedTvChannels,
            originSelectors: true,
            oldTvChanels: oldSelectedItems.tvChannels,
          }),
        );

        return updated;
      });
    },
    [dispatch, selectedItems, validSelectGroups, hiringDetails, idCard, items, oldSelectedItems],
  );

  const getOnChangeHandler = useCallback(
    (groupIndex, inputIndex, imputName) => (selectedValue, param, labelRecomendador) => {
      handleSelectChange(groupIndex, inputIndex, selectedValue, labelRecomendador, imputName);
    },
    [handleSelectChange],
  );

  function changeLabelForRecomender(array) {
    return array.map((item) => ({
      ...item,
      label: item.labelRecomendador,
    }));
  }

  useEffect(() => {
    validSelectGroups.forEach((group, groupIdx) => {
      group.inputSelects.forEach((selectInput, idx) => {
        let options = selectInput.options.sort((a, b) => a.order - b.order);
        options = changeLabelForRecomender(options);
        const currentValue = selectedOptions[groupIdx]?.[idx] || options[0]?.value || '';
        const currentOption = options.find((opt) => opt.value === currentValue) || options[0];

        if (
          currentOption
          && options[0]
          && currentOption.value === options[0].value
        ) {
          const inputId = `inputInSelect${currentOption.labelRecomendador}`;
          const inputEl = document.getElementById(inputId);
          if (inputEl && document.activeElement !== inputEl) {
            inputEl.value = selectInput.defaultName || currentOption.labelRecomendador;
          }
          if (inputEl) {
            inputEl.addEventListener('focus', function handleFocus() {
              inputEl.value = currentOption.labelRecomendador;
              inputEl.removeEventListener('focus', handleFocus);
            });
          }
        }
      });
    });
  }, [selectedOptions, validSelectGroups]);

  return (
    <div className="Card_content">
      <div className="Card_content-action">
        {validSelectGroups.map((group, groupIdx) => (
          <div
            key={`group-${group.idData}`}
            className="Card_content-action__selectors"
            role="presentation"
            onClick={(e) => e.stopPropagation()}
          >
            {group.inputSelects.map((selectInput, idx) => {
              const imputName = selectInput.name;
              let options = selectInput.options.sort((a, b) => a.order - b.order);
              options = changeLabelForRecomender(options);

              const currentValue = selectedOptions[groupIdx]?.[idx] || options[0]?.value || '';
              const currentOption = options.find(
                (opt) => opt.value === currentValue,
              ) || options[0] || {};

              let shouldShowDefaultName = null;
              if (selectInput?.defaultName) {
                shouldShowDefaultName = currentOption.value === '0' && selectInput.defaultName;
              }

              return (
                <Select
                  className="Card_content-action__selectors"
                  key={`${group.idData}-${idx}`}
                  name={`${group.idData}-${currentOption.id}-${currentOption.labelRecomendador}`}
                  ariaLabel={selectInput.name ? `Plan ${selectInput.name}` : selectInput.defaultName || `Opción ${idx + 1}`}
                  activeSelectId={activeSelectId}
                  setActiveSelectId={setActiveSelectId}
                  instanceId={`select-${groupIdx}-${idx}`}
                  options={options}
                  defaultValue={shouldShowDefaultName
                    ? selectInput.defaultName
                    : currentOption.value}
                  value={shouldShowDefaultName ? {
                    value: '',
                    labelRecomendador: selectInput.defaultName,
                    isDisabled: true,
                  } : options.find((opt) => opt.value === currentValue)}
                  onChange={getOnChangeHandler(groupIdx, idx, imputName)}
                  required={false}
                  isSearchable={false}
                  size="small"
                />
              );
            })}
          </div>
        ))}
      </div>
      <style jsx>
        {`
        .Card_content-action__selectors {
          position: relative;
        }
      `}
      </style>
    </div>
  );
};

export default CardSelect;
